import { CONNECTOR_TYPES } from '../../../../constant/Text.constant';

// ChargeLab connector types the finder can search for, with their OCM ConnectionType IDs
// (from GET /v3/referencedata). Order is the dropdown order.
export const FINDER_CONNECTORS: { type: string; ocmIds: number[] }[] = [
  { type: CONNECTOR_TYPES.J1772, ocmIds: [1] },
  { type: CONNECTOR_TYPES.CCS, ocmIds: [32] },
  { type: CONNECTOR_TYPES.CHADEMO, ocmIds: [2] },
  { type: CONNECTOR_TYPES.NACS, ocmIds: [27] },
  { type: CONNECTOR_TYPES.TYPE_2, ocmIds: [25, 1036] },
  { type: CONNECTOR_TYPES.TYPE_2_CCS, ocmIds: [33] },
  { type: CONNECTOR_TYPES.GBT_AC, ocmIds: [1038, 1039] },
  { type: CONNECTOR_TYPES.GBT_DC, ocmIds: [1040] },
];

// Port connector values that are aliases or combinations of the finder connectors
const CONNECTOR_ALIASES: Record<string, string[]> = {
  [CONNECTOR_TYPES.DUAL_J1772]: [CONNECTOR_TYPES.J1772],
  [CONNECTOR_TYPES.DUAL_CCS]: [CONNECTOR_TYPES.CCS],
  [CONNECTOR_TYPES.CCS_CHADEMO]: [CONNECTOR_TYPES.CCS, CONNECTOR_TYPES.CHADEMO],
  [CONNECTOR_TYPES.TYPE_2_CHADEMO_TYPE_2_CCS]: [
    CONNECTOR_TYPES.TYPE_2,
    CONNECTOR_TYPES.CHADEMO,
    CONNECTOR_TYPES.TYPE_2_CCS,
  ],
  [CONNECTOR_TYPES.TESLA]: [CONNECTOR_TYPES.NACS],
};

// Keyed by lower case so "TESLA" and "Tesla" both resolve
const FINDER_TYPES_BY_PORT_CONNECTOR = new Map<string, string[]>([
  ...Object.entries(CONNECTOR_ALIASES).map(([alias, types]): [string, string[]] => [
    alias.toLowerCase(),
    types,
  ]),
  ...FINDER_CONNECTORS.map(({ type }): [string, string[]] => [type.toLowerCase(), [type]]),
]);

const FINDER_TYPE_BY_OCM_ID = new Map<number, string>(
  FINDER_CONNECTORS.flatMap(({ type, ocmIds }) => ocmIds.map((id): [number, string] => [id, type])),
);

/** Expands a port connector value (e.g. "CCS + CHAdeMO", "Tesla") to finder connector types */
export const toFinderConnectorTypes = (portConnectorType: string): string[] =>
  FINDER_TYPES_BY_PORT_CONNECTOR.get(portConnectorType.toLowerCase()) ?? [];

export const getOcmConnectionTypeIds = (connectorTypes: string[]): number[] =>
  FINDER_CONNECTORS.filter(({ type }) => connectorTypes.includes(type)).flatMap(
    ({ ocmIds }) => ocmIds,
  );

/** ChargeLab connector type for an OCM ConnectionType ID, used to pick the connector icon */
export const getConnectorTypeFromOcm = (ocmConnectionTypeId?: number | null) =>
  ocmConnectionTypeId != null ? FINDER_TYPE_BY_OCM_ID.get(ocmConnectionTypeId) : undefined;
